import React, { ForwardedRef } from 'react';
import { SherlockDef } from '../../../../types/sherlock/sherlock.def';

interface PaymentFormProps {
  sherlock: SherlockDef;
}

// eslint-disable-next-line react/display-name
const PaymentForm = React.forwardRef(
  ({ sherlock }: PaymentFormProps, ref: ForwardedRef<HTMLFormElement>) => {
    return (
      <form ref={ref} method="post" action={sherlock.redirectionUrl}>
        <input
          type="hidden"
          name="InterfaceVersion"
          value={sherlock.interfaceVersion}
        />
        <input type="hidden" name="Data" value={sherlock.data} />
        <input type="hidden" name="Seal" value={sherlock.seal} />
      </form>
    );
  }
);
export default PaymentForm;
